<template>
  <div>
    <h2>Feedback</h2>
    <div v-for="(feedback, index) in feedbacks" :key="index" class="mb-5">
      <div class="d-flex justify-space-between align-center">
        <h3 class="mt-4 mb-2">
          {{ feedback.interviewer | fullName }}
        </h3>
        <Permissioned section="interviews.edit">
          <EditFeedbackAction permission="feedback" :feedback="feedback" />
        </Permissioned>
      </div>
      <!-- WIP -->
      <!-- <div
        class="score-field"
        v-for="(item, index) in feedback.scores"
        :key="index"
      >
        {{ item.criteria.criteriaName | capitalize }}
        <Chip> {{ item.score }} </Chip>
      </div> -->
      <div class="font-weight-bold mt-0 mb-2">Internal Notes</div>
      <Note :text="feedback.internalNotes" isSelf />
      <FileUpload
        v-if="feedback.file"
        customActions
        disabled
        :files="[feedback.file]"
        :fileTypes="['application/pdf']"
        @show="onShow"
      />
      <PDFViewFull :data="fileDialog" />
      <Permissioned vertical section="interviews.view">
        <div permission="candidate-feedback">
          <div class="font-weight-bold mt-0 mb-2">
            Candidate Feedback
          </div>
          <span class="font-italic">
            {{ feedback.candidateFeedback }}
          </span>
        </div>
      </Permissioned>
    </div>
    <!-- WIP
    <p class="font-weight-bold mt-0 mb-2">
      Summary
    </p>
    <div class="d-flex justify-end">
      <p class="font-weight-bold mr-2">
        Average
      </p>
      <p class="font-weight-bold mr-2">
        Total
      </p>
    </div>
    <div
      class="score-field"
      v-for="(criteria, criteriaName) in criteriaSum"
      :key="criteriaName"
    >
      {{ criteriaName | capitalize }}
      <div>
        <Chip class="mr-2">
          {{ (criteria.totalScore / feedbackCount).toFixed(2) }}
        </Chip>
        <Chip> {{ criteria.totalScore }} </Chip>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Chip from "@/components/common/Chip";
// import { size } from "lodash";
import Note from "@/components/common/Notes/Note";
import FileUpload from "@/components/common/FileUpload";
import PDFViewFull from "@/components/common/PDFViewFull";
import { getToken } from "@/services/utils";
import { toString } from "lodash";
import Permissioned from "@/components/common/Permissioned";
import EditFeedbackAction from "@/views/interviews/actions/EditFeedbackAction";

export default {
  name: "InterviewFeedbackSection",
  components: {
    // Chip,
    Note,
    PDFViewFull,
    FileUpload,
    Permissioned,
    EditFeedbackAction
  },
  props: {
    feedbacks: Array
  },
  data() {
    return {
      fileDialog: {
        title: "",
        dialog: false,
        src: ""
      }
    };
  },
  computed: {
    // WIP
    // criteriaSum() {
    //   return this.feedbacks.reduce(
    //     (criteriaSum, { scores, totalScore: totalFeedbackScore }) => {
    //       scores.forEach(({ score, criteria }) => {
    //         const { criteriaName } = criteria;
    //         criteriaSum[criteriaName] = {
    //           totalScore: criteriaSum[criteriaName]
    //             ? criteriaSum[criteriaName].totalScore + score
    //             : score
    //         };
    //       });
    //       criteriaSum.total = {
    //         totalScore: criteriaSum.total
    //           ? criteriaSum.total.totalScore + totalFeedbackScore
    //           : totalFeedbackScore
    //       };
    //       return criteriaSum;
    //     },
    //     {}
    //   );
    // },
    // feedbackCount() {
    //   return size(this.feedbacks);
    // }
  },
  methods: {
    onShow(file) {
      const token = getToken();
      this.fileDialog = {
        src: `${file.url}?token=${token}`,
        title: file.fileName,
        dialog: true
      };
    },
    toString
  }
};
</script>

<style lang="scss"></style>
